import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'


class UsuarioApiClient {

    async buscarDadosDoUsuarioAutenticado() {
        return await axios.get('/sessao/info-sessao-usuario')
    }

    async buscarTodos(filtros, paginacao) {
        const url = SearchUrlBuilder.build(
            '/usuario',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async buscarId(id) {
        return await axios.get(`/usuario/${id}`)
    }

    async cadastrar(dados) {
        return await axios.post('/usuario/inserir', dados)
    }

    async editar(dados) {
        return await axios.put(`/usuario/${dados.id}`, dados)
    }

    async remover(id) {
        return await axios.delete(`/usuario/delete/${id}`)
    }

    async buscarAvatares() {
        return await axios.get('/usuario/buscarAvatares')
    }

    async atualizarFotoAvatar(dados) {
        const formData = new FormData()
        formData.append('arquivo', dados.arquivo)
        return await axios.put('/usuario/uploadAvatar', formData)
    }

    async selecionarAvatar(dados) {
        return await axios.put('/usuario/selecionarAvatar', dados)
    }

}

export default new UsuarioApiClient()
